/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_None_DescriptionInputs */



/**
* | output |
* | --- |
* | "When an administrator gives you access to an integration, or you connect one yourself, it appears here." |
*
* @param {My_Integrations_None_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_none_description = /** @type {((inputs?: My_Integrations_None_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_None_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sobald eine Administratorin Ihnen Zugriff auf eine Integration gibt oder Sie selbst eine verbinden, erscheint sie hier.")
	return /** @type {LocalizedString} */ ("When an administrator gives you access to an integration, or you connect one yourself, it appears here.")
});